import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { RiArchiveDrawerLine } from "react-icons/ri";
import { memo } from "react";

export function EdgeDrawerIcon(props) {
  return (
    <div style={{ display: "flex", position: "relative" }}>
      <RiArchiveDrawerLine {...props} />
      <ArrowForwardIosIcon {...props} style={{ position: "absolute", left: 14, top: 1 }} />
    </div>
  );
}

export default memo(EdgeDrawerIcon);
